import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { Input } from '../../ui-kit/Input/Input.js';
import { Select } from '../../ui-kit/Select/Select.js';
export function renderInput(props) {
    const { placeholder, rates, selected, value, setValue, setSelected } = props;
    const ratesOptions = rates.map((_) => ({
        key: _?.currency?.currency ?? '',
        text: _?.currency?.currency ?? '',
    }));
    const selectedValue = { key: selected, text: selected };
    return (_jsxs("div", { className: "relative flex", children: [_jsx(Input, { className: "shrink-0 text-l w-full appearance-none -mr-20", placeholder: placeholder, type: "text", value: value, onChange: setValue }), ratesOptions.length ? (_jsx(Select, { className: "absolute right-0", isBorder: false, onChange: (_) => setSelected(_.key), options: ratesOptions, value: selectedValue })) : null] }));
}
//# sourceMappingURL=renderInput.js.map